/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-throw-literal */
import React from "react";
import { errorMessage } from "../../../utils";
import {
  downloadReport,
  getAccountOverwriteHistoriesApi,
} from "../api/ListApis";
import { useImmer } from "use-immer";
import { useParams } from "react-router-dom";
import { CustomTable } from "../../../shared";
import { Box, Link } from "@mui/material";
import fileDownload from "js-file-download";

export const AccountUploadHistory = () => {
  const { state } = useAccountUploadHistory();

  const columns = React.useMemo(
    () => [
      {
        Header: "Uploaded on",
        accessor: "updated_on",
      },
      {
        Header: "Submitted By",
        accessor: "user_name",
      },

      {
        Header: "File",
        accessor: "file",
        Cell: ({ row }) => {
          return (
            <Box
              sx={{
                textDecoration: "none",
                cursor: "pointer",
                color: "blue",
              }}
            >
              {row.original.file ? (
                <Link
                  underline="none"
                  component="a"
                  variant="body2"
                  href={row?.original?.file}
                >
                  <b>Download</b>
                </Link>
              ) : (
                "--"
              )}
            </Box>
          );
        },
      },
    ],
    []
  );

  return (
    <CustomTable
      columns={columns}
      data={state.accountUploadHistoryList}
      isLoading={state.tableLoading}
    />
  );
};

const useAccountUploadHistory = () => {
  const { id } = useParams();
  const [state, setState] = useImmer({
    accountUploadHistoryList: [],
    tableLoading: true,
  });
  //   ======================================================== API SECTION =====================================================
  const getAccountUploadHistories = async ({ accountUploadId }) => {
    triggerTableLoading(true);
    try {
      const response = await getAccountOverwriteHistoriesApi({
        accountUploadId,
      });
      const { success, message, data } = response;
      if (success) {
        setState((draft) => {
          draft.accountUploadHistoryList = data;
        });
      } else {
        throw {
          response: {
            data: {
              message,
            },
          },
        };
      }
    } catch (error) {
      const message =
        error.response.data.message ??
        "Failed to fetch account upload histories";
      errorMessage(message);
    } finally {
      triggerTableLoading(false);
    }
  };

  const downloadUploadedFile = async (id) => {
    try {
      const res = await downloadReport(id);
      const content = res.headers["content-type"];
      fileDownload(res.data, `PL&BS_upload_file.xlsx`, content);
    } catch (err) {
      errorMessage(err.response.data.message);
    }
  };

  //   ========================================================== UTIL FUNCTION SECTION ===============================================

  const triggerTableLoading = (loading) => {
    setState((draft) => {
      draft.tableLoading = loading;
    });
  };
  //   ========================================================== USE EFFECT SECTION ===============================================
  React.useEffect(() => {
    getAccountUploadHistories({
      accountUploadId: id,
      searchText: state.searchText,
    });
  }, []);

  return { state, downloadUploadedFile };
};
